import { LocationPath } from '../location';
import { BatchStatus, ProductionWorkOrderStatus } from '../production/production-work-order';

export const ENTITY_DEF_BATCH = 41;
export const FROM_LOCATION_CODE = 'PC.WH-RM-1';
export const TO_LOCATION_CODE = 'PC.WH-PROD-1';
export const LOT_ITEM_SEARCH_LOCATION: LocationPath = { siteCode: 'PC', warehouseCode: 'WH-RM-1' };

export const VALID_PWO_STATUSES: ProductionWorkOrderStatus[] = [ProductionWorkOrderStatus.Approved, ProductionWorkOrderStatus.InProduction];
export const VALID_BATCH_STATUSES: BatchStatus[] = [BatchStatus.Approved, BatchStatus.ReadyForProduction, BatchStatus.InProduction];
